import React, { Suspense } from "react";

import loaderWithRetry from "seneca-common/utils/loaderWithRetry";

import SpinnerLoadingScreen from "features/common/loadingScreens/components/SpinnerLoadingScreen";
import ParentDashboardLayout from "features/parents/components/layout/ParentDashboardLayout";
import ParentContextProvider from "features/parents/context/ParentContextProvider";
import { linkToMonitoringPage } from "features/parents/links";
import { linkToTutoringPage } from "features/parents/routes/parent/routes/tutoring-page/links";
import { linkToSignIn, linkToSignUp } from "features/sign-up/links";

import AnonymousPageLayout from "../common/AnonymousPageLayout";
import useRedirectIfInitiallySignedIn from "../common/hooks/useRedirectIfInitiallySignedIn";
import useRedirectIfNonGB from "../common/hooks/useRedirectIfNonGB";

const TutoringPage = React.lazy(() =>
  loaderWithRetry(
    () =>
      import(
        /* webpackChunkName: "parent-tutoring-page" */ "features/parents/pages/tutoring-page/TutoringPage"
      )
  )
);

const ClaimTutoringJourneyRoutes = React.lazy(() =>
  loaderWithRetry(
    () =>
      import(
        /* webpackChunkName: "parent-claim-tutoring-journey-routes" */ "features/parents/claim-tutoring-journey/routes/Route"
      )
  )
);

export default function AnonymousTutoringRoute() {
  useRedirectIfInitiallySignedIn(linkToTutoringPage());
  useRedirectIfNonGB(linkToMonitoringPage());

  return (
    <AnonymousPageLayout
      linkToSignIn={linkToSignIn()}
      linkToSignUp={linkToSignUp()}
    >
      <ParentContextProvider>
        <ParentDashboardLayout>
          <Suspense fallback={<SpinnerLoadingScreen color="dark" />}>
            <TutoringPage />
            <ClaimTutoringJourneyRoutes />
          </Suspense>
        </ParentDashboardLayout>
      </ParentContextProvider>
    </AnonymousPageLayout>
  );
}
